/**
 * 📧 メール Hub
 *
 * v3.3 IA 刷新: mail.* を統合した親ページ。配信先/グループ/リード はオーディエンス Hub に分離。
 *
 * v3.3.1: 「生成」タブを廃止。新規メール作成は「メール」タブ内の
 * 「+ 新規メール（空白）」ボタン、または既存メールクリックで /mail/generate
 * (メール作成/編集画面) に遷移する形に統一。
 */
import { HubTabs, type TabSpec } from '@/components/layout/HubTabs';

import { MailListPage } from './list/MailListPage';
import { MailSchedulesPage } from './schedules/MailSchedulesPage';
import { MailAnalysisPage } from './analysis/MailAnalysisPage';
import { MailSettingsPage } from './settings/MailSettingsPage';

const TABS: TabSpec[] = [
  { tabKey: 'list',      label: 'メール',   featureId: 'mail.list',      render: () => <MailListPage /> },
  { tabKey: 'schedules', label: '配信予約', featureId: 'mail.schedules', render: () => <MailSchedulesPage /> },
  { tabKey: 'analysis',  label: '意図設定', featureId: 'mail.analysis',  render: () => <MailAnalysisPage /> },
  { tabKey: 'settings',  label: '設定',     featureId: 'mail.settings',  render: () => <MailSettingsPage /> },
];

export function MailHubPage() {
  return <HubTabs tabs={TABS} defaultTab="list" />;
}
